import useAuth from 'hooks/useAuth';
import { useSelector } from 'store';
import notifyCaptureSuppressed from 'utils/notifyCaptureSuppressed';

export default function useSendText() {
  const { functions } = useAuth();
  const clientTextSend = functions.httpsCallable('clientTextSend');
  const captureNotifications = useSelector(
    (state) => (state.config?.mainConfig as any)?.notificationSettings?.captureNotifications === true
  );

  const sendText = async (contactId: string, body: string) => {
    // --- CAPTURE ---
    // config/notificationSettings.captureNotifications on → log, don't deliver.
    if (captureNotifications) {
      console.log('[CAPTURE] text suppressed — not delivered', { contactId, body });
      notifyCaptureSuppressed('Text');
      return { data: { captured: true } } as any;
    }
    const message = await clientTextSend({ contactId, body });
    return message;
  };

  return sendText;
}
